var exports = {
  "G": "x61f99309--1bc22c--image_block",
};

module.exports = exports;
